import { useEffect, useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

// Kapalıyken gösterilecek yükseklik (px). İçerik bundan kısaysa açılır/kapanır
// davranış devreye girmez, içerik olduğu gibi gösterilir.
const COLLAPSED_HEIGHT = 160;

// Editörden gelen boş paragrafları (<p><br></p>, <p class="..."><br/></p>)
// tek bir satır boşluğuna (<br/>) çevirir; diğer içerik olduğu gibi kalır.
const replaceEmptyParagraphs = (html) =>
	(html ?? "").replace(/<p(\s[^>]*)?>\s*<br\s*\/?>\s*<\/p>/gi, "<br/>");

// Uzun HTML açıklamalarını etkinlik banner'ıyla aynı görünümde bir kartta,
// kısaltılmış olarak gösterir. Kapalıyken alt kısım beyaza doğru erir ve
// üzerine binen "Devamını oku" butonu içeriği açar/kapatır.
const CollapsibleDescription = ({
	html,
	titleId = "eventDescription",
	iconColor = "#fff",
}) => {
	const sectionRef = useRef(null);
	const textRef = useRef(null);
	const [expanded, setExpanded] = useState(false);
	const [fullHeight, setFullHeight] = useState(0);

	// İçeriğin gerçek yüksekliğini ölç; görseller yüklenince ya da genişlik
	// değişince yeniden ölçülsün diye ResizeObserver kullanılıyor.
	useEffect(() => {
		const el = textRef.current;
		if (!el) return;
		const measure = () => setFullHeight(el.scrollHeight);
		measure();
		if (typeof ResizeObserver === "undefined") return;
		const observer = new ResizeObserver(measure);
		observer.observe(el);
		return () => observer.disconnect();
	}, [html]);

	const isCollapsible = fullHeight > COLLAPSED_HEIGHT + 60;
	const isCollapsed = isCollapsible && !expanded;

	const toggle = () => {
		// Kapatırken kartın başı ekranın dışında kalmasın
		if (expanded) {
			sectionRef.current?.scrollIntoView({ behavior: "smooth", block: "nearest" });
		}
		setExpanded((prev) => !prev);
	};

	return (
		<section ref={sectionRef} className="event-about">
			<header className="event-about__head">
				<span className="event-about__icon" style={{ color: iconColor }}>
					<InfoOutlinedIcon />
				</span>
				<h2 className="event-about__title">
					<FormattedMessage id={titleId} />
				</h2>
			</header>

			<div
				className={`event-about__body${isCollapsed ? " is-collapsed" : ""}`}
				style={
					isCollapsible
						? { maxHeight: isCollapsed ? COLLAPSED_HEIGHT : fullHeight }
						: undefined
				}
			>
				<div
					ref={textRef}
					className="event-about__text"
					dangerouslySetInnerHTML={{ __html: replaceEmptyParagraphs(html) }}
				/>
				<div className="event-about__fade" aria-hidden="true" />
			</div>

			{isCollapsible && (
				<div className="event-about__footer">
					<button
						type="button"
						className={`event-about__toggle${expanded ? " is-expanded" : ""}`}
						onClick={toggle}
						aria-expanded={expanded}
					>
						<FormattedMessage id={expanded ? "showLess" : "showMore"} />
						<span className="event-about__toggle-icon">
							<KeyboardArrowDownIcon />
						</span>
					</button>
				</div>
			)}
		</section>
	);
};

export default CollapsibleDescription;
